import { render, staticRenderFns } from "./client-input.vue?vue&type=template&id=c5c5d96a&"
import script from "./client-input.vue?vue&type=script&lang=js&"
export * from "./client-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports